import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../../../config/AuthContext";
import { FloatButton, Skeleton } from "antd";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { BiPencil } from "react-icons/bi";
import ReactMarkdown from "react-markdown";
import TextArea from "antd/es/input/TextArea";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { GetProjecteIdConfiguracio } from "../../../../dao/abp/GetProjecteIdConfiguracio";
import { useParams } from "react-router-dom";
import { GetProjecteId } from "../../../../dao/abp/GetProjecteId";
import { PutDocument } from "../../../../dao/abp/PutDocument";
import { BiSave, BiX } from "react-icons/bi"; // Added icons

const ProjecteIdEnunciat = ({ doc }: { doc: any }) => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_projecte } = useParams();
    const [edit, setEdit] = useState(false);
    const [docs, setDocs] = useState<any>({});
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [doc]);

    async function checkDades() {
        setLoading(true);
        const data = await GetProjecteId(id_projecte + "", 0);
        const currentDoc = data?.docs?.find((d: any) => d.id === doc.id);
        setDocs(currentDoc);
        setText(currentDoc?.descripcio || "");
        setLoading(false);
    }

    const saveDoc = async () => {
        setLoading(true);
        try {
            await PutDocument(docs.id, docs.nom, text);
            setDocs({ ...docs, descripcio: text });
            setEdit(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    if (!doc) return <p>No s'ha seleccionat cap document.</p>;

    return (
        <>
            {loading ? (
                <Skeleton loading={loading} />
            ) : (
                <div>
                    <h5>{docs.nom}</h5>

                    {/* Edit Mode: TextArea */}
                    {edit ? (
                        <div style={{ position: 'relative' }}>
                            <TextArea
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                autoSize={{ minRows: 10, maxRows: 30 }}
                                style={{ marginBottom: 60 }}
                            />
                        </div>
                    ) : (
                        <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                            rehypePlugins={[rehypeRaw]}
                        >
                            {docs.descripcio}
                        </ReactMarkdown>
                    )}

                    {/* Floating Buttons */}
                    {(user.tipus === "1" || user.tipus === "0") && (
                        <FloatButton.Group
                            shape="circle"
                            style={{ right: 94 }}
                        >
                            {edit ? (
                                <>
                                    <FloatButton
                                        icon={<BiSave />}
                                        type="primary"
                                        onClick={saveDoc}
                                        tooltip="Guardar canvis"
                                    />
                                    <FloatButton
                                        icon={<BiX />}
                                        onClick={() => {
                                            setEdit(false);
                                            setText(docs.descripcio); // Reset text on cancel
                                        }}
                                        tooltip="Cancel·lar"
                                    />
                                </>
                            ) : (
                                <FloatButton
                                    icon={<BiPencil />}
                                    onClick={() => {
                                        setEdit(true);
                                        setText(docs.descripcio);
                                    }}
                                    style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                                    tooltip="Editar document"
                                />
                            )}
                        </FloatButton.Group>
                    )}
                </div>
            )}
        </>
    );

};

export default ProjecteIdEnunciat;
